export default "__VITE_ASSET__73eccp4p__"